import React from "react"
import Layout from "../Layout/index"
import PriceTable from "./price_table"
import { Fragment, useState, useEffect } from 'react'
import AdminService from '../../services/admin/AdminService';
import PriceUpdate from "./price_update"
import { Link } from "react-router-dom"
import { sideBarItems } from '../../utils';
import _ from 'lodash'
import { toast } from "react-hot-toast";

const PriceList = () => {
  const [owners, setOwners] = useState([]);
  const [locations, setLocations] = useState([]);
  const [fares, setFares] = useState([]);
  const [filteredFares, setFilteredFares] = useState([]);
  const [selectedFareItem, setSelectedFareItem] = useState();
  const [showUpPrice, setShowUpPrice] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [rentalRates, setRentalRates] = useState({ Sedan_4: 25, Micro_7: 30, Micro_10: 35, Micro_15: 40 });
  const [savingConfig, setSavingConfig] = useState(false);

  const setUpdatePrice = (selectedFareItem) => {
    setVisibleModal(true)
    setSelectedFareItem(selectedFareItem)

  }

  useEffect(() => {
    callApis()
  }, [])

  const callApis = () => {
    AdminService.getFareChart().then(data => {
      setFares(data.data);
      setFilteredFares(data.data);
    });
    AdminService.getRentalFareConfig().then(res => {
      if (res?.success && res?.config?.rates) {
        setRentalRates(res.config.rates);
      }
    });
  }

  const handleSaveRentalRates = () => {
    setSavingConfig(true);
    AdminService.updateRentalFareConfig({ rates: rentalRates })
      .then(res => {
        if (res?.success) {
          toast.success("Rental pricing configuration saved successfully!");
        } else {
          toast.error("Failed to save rental pricing settings");
        }
      })
      .catch(err => {
        console.error("Error saving rental rates:", err);
        toast.error("Error saving rental rates");
      })
      .finally(() => {
        setSavingConfig(false);
      });
  };

  const handleChangeSearch = (searchQuery) => {
    let filteredFares = _.filter(fares, item => {
      return item?.from?.match(new RegExp(searchQuery, 'gi'))
        || item?.to?.match(new RegExp(searchQuery, 'gi'))

    });
    setFilteredFares(_.isEmpty(searchQuery) ? fares : filteredFares)
  }

  const handleModal = (isVisible) => {
    setVisibleModal(isVisible)
  }

  return (
    <Layout
      handleChangeSearch={handleChangeSearch}
      modal={<PriceUpdate
        selectedFareItem={selectedFareItem}
        showUpPrice={showUpPrice}
        refresh={callApis}
      // handleModal={handleModal}
      />}
      visibleModal={visibleModal}
      handleModal={handleModal}
      title={sideBarItems.price.key}>
      <div className="-ml-6 w-full mr-10 mt-10  ">
        {/* Rental Pricing Config Section */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8 shadow-sm transition-all hover:shadow-md">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 border-b border-gray-100 pb-4 gap-4">
            <div>
              <h2 className="text-xl font-bold text-gray-950 flex items-center gap-2">
                <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Rental Per KM Fare Configuration
              </h2>
            </div>
            <button
              onClick={handleSaveRentalRates}
              disabled={savingConfig}
              className={`px-5 py-2 text-white font-semibold rounded-lg shadow-sm transition-all duration-200 flex items-center gap-2 ${
                savingConfig 
                  ? 'bg-indigo-400 cursor-not-allowed' 
                  : 'bg-indigo-600 hover:bg-indigo-700 hover:shadow active:scale-95'
              }`}
            >
              {savingConfig ? (
                <>
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Saving...
                </>
              ) : (
                <>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                  </svg>
                  Save Settings
                </>
              )}
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Sedan */}
            <div className="border border-gray-100 rounded-lg p-4 bg-gray-50/50 hover:bg-gray-50 transition-colors">
              <div className="flex justify-between items-center mb-3">
                <span className="text-sm font-semibold text-gray-700">Sedan</span>
                <span className="text-xs bg-indigo-50 text-indigo-700 px-2.5 py-0.5 rounded-full font-medium">1-4 seats</span>
              </div>
              <div className="relative rounded-md shadow-sm">
                <input
                  type="number"
                  value={rentalRates.Sedan_4}
                  onChange={(e) => setRentalRates(prev => ({ ...prev, Sedan_4: Number(e.target.value) || 0 }))}
                  className="w-full pl-3 pr-16 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-900 font-semibold"
                  placeholder="25"
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <span className="text-gray-400 sm:text-sm font-medium">৳/km</span>
                </div>
              </div>
            </div>

            {/* Micro 7 */}
            <div className="border border-gray-100 rounded-lg p-4 bg-gray-50/50 hover:bg-gray-50 transition-colors">
              <div className="flex justify-between items-center mb-3">
                <span className="text-sm font-semibold text-gray-700">Micro (5-7 Seats)</span>
                <span className="text-xs bg-teal-50 text-teal-700 px-2.5 py-0.5 rounded-full font-medium">5-7 seats</span>
              </div>
              <div className="relative rounded-md shadow-sm">
                <input
                  type="number"
                  value={rentalRates.Micro_7}
                  onChange={(e) => setRentalRates(prev => ({ ...prev, Micro_7: Number(e.target.value) || 0 }))}
                  className="w-full pl-3 pr-16 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-900 font-semibold"
                  placeholder="30"
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <span className="text-gray-400 sm:text-sm font-medium">৳/km</span>
                </div>
              </div>
            </div>

            {/* Micro 10 */}
            <div className="border border-gray-100 rounded-lg p-4 bg-gray-50/50 hover:bg-gray-50 transition-colors">
              <div className="flex justify-between items-center mb-3">
                <span className="text-sm font-semibold text-gray-700">Micro (8-10 Seats)</span>
                <span className="text-xs bg-teal-50 text-teal-700 px-2.5 py-0.5 rounded-full font-medium">8-10 seats</span>
              </div>
              <div className="relative rounded-md shadow-sm">
                <input
                  type="number"
                  value={rentalRates.Micro_10}
                  onChange={(e) => setRentalRates(prev => ({ ...prev, Micro_10: Number(e.target.value) || 0 }))}
                  className="w-full pl-3 pr-16 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-900 font-semibold"
                  placeholder="35"
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <span className="text-gray-400 sm:text-sm font-medium">৳/km</span>
                </div>
              </div>
            </div>

            {/* Micro 15 */}
            <div className="border border-gray-100 rounded-lg p-4 bg-gray-50/50 hover:bg-gray-50 transition-colors">
              <div className="flex justify-between items-center mb-3">
                <span className="text-sm font-semibold text-gray-700">Micro (11-15 Seats)</span>
                <span className="text-xs bg-teal-50 text-teal-700 px-2.5 py-0.5 rounded-full font-medium">11-15 seats</span>
              </div>
              <div className="relative rounded-md shadow-sm">
                <input
                  type="number"
                  value={rentalRates.Micro_15}
                  onChange={(e) => setRentalRates(prev => ({ ...prev, Micro_15: Number(e.target.value) || 0 }))}
                  className="w-full pl-3 pr-16 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-900 font-semibold"
                  placeholder="40"
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <span className="text-gray-400 sm:text-sm font-medium">৳/km</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Link
          to="/addprice"
          className=" inline-flex items-center justify-center px-2 py-1.5 text-indigo-600 font-medium border border-indigo-600 rounded-md transition duration-300 ease-in-out bg-indigo-50 hover:bg-indigo-100 hover:text-indigo-700 hover:border-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
          // className="inline-flex items-center px-3 py-1.5 border bg-indigo-100 border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-150"
        >
          <svg
            className="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
          Add Price
        </Link>
        {/* <div>
          {showUpPrice &&
            <PriceUpdate
              selectedFareItem={selectedFareItem}
              showUpPrice={showUpPrice}
              setShowUpPrice={setShowUpPrice}
              refresh={callApis}
            />
          }
        </div> */}
        <PriceTable setUpdatePrice={setUpdatePrice} fares={filteredFares} />
      </div>


    </Layout>

  )
};

export default PriceList;